import _classCallCheck from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/docb/git/randomsplinewaves/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Factory } from '../Factory.js';
import { Line } from './Line.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
import { Path } from './Path.js';
export var Arrow = /*#__PURE__*/function (_Line) {
  _inherits(Arrow, _Line);

  var _super = _createSuper(Arrow);

  function Arrow() {
    _classCallCheck(this, Arrow);

    return _super.apply(this, arguments);
  }

  _createClass(Arrow, [{
    key: "_sceneFunc",
    value: function _sceneFunc(ctx) {
      _get(_getPrototypeOf(Arrow.prototype), "_sceneFunc", this).call(this, ctx);

      var PI2 = Math.PI * 2;
      var points = this.points();
      var tp = points;
      var fromTension = this.tension() !== 0 && points.length > 4;

      if (fromTension) {
        tp = this.getTensionPoints();
      }

      var length = this.pointerLength();
      var n = points.length;
      var dx, dy;

      if (fromTension) {
        var lp = [tp[tp.length - 4], tp[tp.length - 3], tp[tp.length - 2], tp[tp.length - 1], points[n - 2], points[n - 1]];
        var lastLength = Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
        var previous = Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
        dx = points[n - 2] - previous.x;
        dy = points[n - 1] - previous.y;
      } else {
        dx = points[n - 2] - points[n - 4];
        dy = points[n - 1] - points[n - 3];
      }

      var radians = (Math.atan2(dy, dx) + PI2) % PI2;
      var width = this.pointerWidth();

      if (this.pointerAtEnding()) {
        ctx.save();
        ctx.beginPath();
        ctx.translate(points[n - 2], points[n - 1]);
        ctx.rotate(radians);
        ctx.moveTo(0, 0);
        ctx.lineTo(-length, width / 2);
        ctx.lineTo(-length, -width / 2);
        ctx.closePath();
        ctx.restore();
      }

      if (this.pointerAtBeginning()) {
        ctx.save();
        ctx.translate(points[0], points[1]);

        if (fromTension) {
          dx = (tp[0] + tp[2]) / 2 - points[0];
          dy = (tp[1] + tp[3]) / 2 - points[1];
        } else {
          dx = points[2] - points[0];
          dy = points[3] - points[1];
        }

        ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
        ctx.moveTo(0, 0);
        ctx.lineTo(-length, width / 2);
        ctx.lineTo(-length, -width / 2);
        ctx.closePath();
        ctx.restore();
      }

      var isDashEnabled = this.dashEnabled();

      if (isDashEnabled) {
        this.attrs.dashEnabled = false;
        ctx.setLineDash([]);
      }

      ctx.fillStrokeShape(this);

      if (isDashEnabled) {
        this.attrs.dashEnabled = true;
      }
    }
  }, {
    key: "getSelfRect",
    value: function getSelfRect() {
      var lineRect = _get(_getPrototypeOf(Arrow.prototype), "getSelfRect", this).call(this);

      var offset = this.pointerWidth() / 2;
      return {
        x: lineRect.x - offset,
        y: lineRect.y - offset,
        width: lineRect.width + offset * 2,
        height: lineRect.height + offset * 2
      };
    }
  }]);

  return Arrow;
}(Line);
Arrow.prototype.className = 'Arrow';

_registerNode(Arrow);

Factory.addGetterSetter(Arrow, 'pointerLength', 10, getNumberValidator());
Factory.addGetterSetter(Arrow, 'pointerWidth', 10, getNumberValidator());
Factory.addGetterSetter(Arrow, 'pointerAtBeginning', false);
Factory.addGetterSetter(Arrow, 'pointerAtEnding', true);